import ActionTypes from '../constants/ActionTypes';
import { getHiprojectsModalState } from './modals';
import Checkpoints from '../constants/Checkpoints';
import JobStates from '../constants/JobStates';
import { getUserLoginState } from './user';
import { State } from '../reducers';

export function isJobLoaded(state, id) {
  return !!(state.jobs.status[id] && state.jobs.status[id] === ActionTypes.FETCH_JOB_SUCCESS);
}

export function isJobAndConnectionsLoaded(state, id) {
  return !!(
    state.jobs.status[id] &&
    state.jobs.status[id] === ActionTypes.FETCH_JOB_SUCCESS &&
    state.jobs.connectionStatus[id] &&
    state.jobs.connectionStatus[id] === ActionTypes.FETCH_JOB_CONNECTIONS_SUCCESS
  );
}

export function getJobById(state, id) {
  return state.jobs.list[id] || {};
}

export function getJobInvitationsById(state, id) {
  return state.jobs.invitations[id];
}

export function getJobConnectionsById(state, id) {
  const connections = (state.jobs.connections[id] && state.jobs.connections[id].connections) || [];
  return connections.map(c => ({
    waitlistStatus: getConnectionWaitlistStatusById(state, c.id),
    ...c
  }));
}

export function getConnectionWaitlistStatusById(state, id) {
  return state.jobs.connectionWaitlistStatus[id];
}

export function getConnectMoreStatusById(state, id) {
  return state.jobs.connectMoreStatus[id];
}

export function hasSeenCheckpoint(state, id, checkpoint) {
  return !!getCheckpoint(state, id, checkpoint);
}

export function getCheckpoint(state, id, checkpoint) {
  const key = `${id}-${checkpoint}`;
  return state.jobs.checkpoints[key];
}

export function isFirstView(state, id) {
  return !!state.jobs.isFirstView[id];
}

export function isDirectEnquiry(state, id) {
  const job = getJobById(state, id);
  return job && job.isDirectEnquiry;
}

export function shouldShowHiprojects(state, id) {
  return isFirstView(state, id) && getHiprojectsModalState(state);
}

export function shouldShowModeration(state, id) {
  return (
    isFirstView(state, id) &&
    !getHiprojectsModalState(state) &&
    !hasSeenCheckpoint(state, id, Checkpoints.SEEN_MODERATION)
  );
}

export function getJobUIState(state, id) {
  const isLoaded = isJobLoaded(state, id);
  const { status } = getJobById(state, id);
  const { loggedIn } = getUserLoginState(state);

  if (!isLoaded) return JobStates.LOADING;
  // Needs more info - show contact message
  if ([7, 11].includes(status)) return JobStates.NEEDS_MORE_INFO;

  // fty=1 flow
  if (isFirstView(state, id)) {
    if (getHiprojectsModalState(state)) return JobStates.HIPROJECTS;
    if (isDirectEnquiry(state, id)) {
      return JobStates.DIRECT_ENQ_WAITING;
    } else {
      if (!hasSeenCheckpoint(state, id, Checkpoints.MODERATION_FINISHED)) {
        return JobStates.MODERATION;
      }
      if (!hasSeenCheckpoint(state, id, Checkpoints.INVITE_ANIMATION_FINISHED)) {
        return JobStates.INVITE_ANIMATION;
      }
    }
  }

  // Check Closed Statuses - Only show connectons if logged in
  if (status === 5) {
    if (hasHiredConnections(state, id) && loggedIn) {
      return JobStates.HIRED_CLOSED;
    } else if (hasConnections(state, id) && loggedIn) {
      return JobStates.CONNECTED_CLOSED;
    }
    return JobStates.CLOSED;
  }

  // Again, only show connections if logged in
  if (loggedIn) {
    if (status === 12 || hasHiredConnections(state, id)) return JobStates.HIRED;
    if (hasConnections(state, id)) return JobStates.CONNECTED;
  }

  // Else, we are waiting for connections
  if (isDirectEnquiry(state, id)) {
    return JobStates.DIRECT_ENQ_WAITING;
  }
  return JobStates.WAITING_FOR_CONNECTION;
}

export function hasHiredConnections(state, id) {
  const connections = getJobConnectionsById(state, id) || [];
  return !!connections.filter(c => c.status === 12).length;
}

export function hasConnections(state, id) {
  const connections = getJobConnectionsById(state, id) || [];
  return !!connections.length;
}

export function timeSinceCheckpoint(state, id, checkpoint, now) {
  if (!hasSeenCheckpoint(state, id, checkpoint)) return;
  const { time } = getCheckpoint(state, id, checkpoint);
  const comparedTo = now || +new Date();
  return comparedTo - time;
}

export function getCloseJobSuccessMessage(state) {
  return state.jobs.closeJob;
}

export function getUserJobWithTradieId(state: State, siteId) {
  const user = getUserLoginState(state);
  if (!user.loggedIn) return -1;
  if (!state.jobs.sites[siteId]) return -1;
  return state.jobs.sites[siteId].job_id || -1;
}
